import store from './index';
import waja from 'waja';

function defaultState () {
	return {
		hasUnrestrictedShipping: [],
		horizonEnabled: null,
		imiGoShippingMethodsMap: {},
		reSupplyPointId: 0,
		shippingStoresByPrioOrder: [],
		splittableShippingOptions: [],
		fromStoreShipmentOptions: [],
		eolFromStoreShipmentEnabled: 0,
		warehouses: [],
	};
}

store.registerModule('shippingMethodRelatedInfo', {
	namespaced: true,
	state: defaultState(),
	actions: {
		getShippingMethodRelatedInfo({ commit }) {
			waja.get('shipping-method/related-info')
				.on('success', res => {
					commit('setShippingStoresByPrioOrder', res.data.shippingStoresByPrioOrder);
					commit('setSplittableShippingOptions', res.data.splittableShippingOptions);
					commit('setFromStoreShipmentOptions', res.data.fromStoreShipmentOptions);
					commit('setImiGoShippingMethodsMap', res.data.imiDeliveryCodeTranslation);
					commit('setReSupplyPointId', res.data.supplyPoint);
					commit('setHorizonEnabled', res.data.horizonEnabled);
					commit('setEolFromStoreShipmentEnabled', res.data.eolFromStoreShipmentEnabled);
					commit('setHasUnrestrictedShipping', res.data.hasUnrestrictedShipping);
					commit('setWarehouses', res.data.warehouses);
				}).go();
		},
	},
	mutations: {
		setShippingStoresByPrioOrder (state, value) {
			state.shippingStoresByPrioOrder = value;
		},
		setSplittableShippingOptions (state, value) {
			state.splittableShippingOptions = value;
		},
		setFromStoreShipmentOptions (state, value) {
			state.fromStoreShipmentOptions = value;
		},
		setHorizonEnabled (state, value) {
			state.horizonEnabled = value;
		},
		setEolFromStoreShipmentEnabled (state, value) {
			state.eolFromStoreShipmentEnabled = value;
		},
		setImiGoShippingMethodsMap (state, value) {
			state.imiGoShippingMethodsMap = value;
		},
		setReSupplyPointId (state, value) {
			state.reSupplyPointId = value;
		},
		setHasUnrestrictedShipping (state, value) {
			state.hasUnrestrictedShipping = value;
		},
		setWarehouses (state, value) {
			state.warehouses = value;
		},
	},
});
